import { createRouter, createWebHistory } from 'vue-router'; // Cambiado a createWebHistory
import HomeView from '../views/HomeView.vue'; // Crearemos este componente HomeView
import LoginView from '../views/LoginView.vue';
import SignupView from '../views/SignupView.vue';
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue'; // Import Privacy Policy
import TermsConditionsView from '../views/TermsConditionsView.vue'; // Import Terms & Conditions
import NotFoundView from '../views/NotFoundView.vue'; // Import NotFoundView

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/signup',
    name: 'Signup',
    component: SignupView
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyView // Add route for Privacy Policy
  },
  {
    path: '/terms-conditions',
    name: 'TermsConditions',
    component: TermsConditionsView // Add route for Terms & Conditions
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundView // Add route for NotFound
  }
  // Puedes añadir más rutas aquí
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // Cambiado a createWebHistory
  routes
});

export default router;
